import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { Box, Stack, Text } from "@chakra-ui/react";
import { CheckboxControl } from "formik-chakra-ui";
import { StartStack } from "@inspire/ui/chakra/layout/Stack";
export var FormFrame = function(_param) /*#__PURE__*/ {
    var children = _param.children, legend = _param.legend, legendProps = _param.legendProps, stackProps = _param.stackProps, boxProps = _object_without_properties(_param, [
        "children",
        "legend",
        "legendProps",
        "stackProps"
    ]);
    return _jsxs(Box, _object_spread_props(_object_spread({
        as: "fieldset",
        pt: legend ? 2 : 4
    }, boxProps), {
        children: [
            legend && /*#__PURE__*/ _jsx(Box, _object_spread_props(_object_spread({
                as: "legend"
            }, legendProps), {
                children: legend
            })),
            /*#__PURE__*/ _jsx(StartStack, _object_spread_props(_object_spread({
                spacing: 5
            }, stackProps), {
                children: children
            }))
        ]
    }));
};
export var FormStack = function(_param) /*#__PURE__*/ {
    var children = _param.children, stackProps = _object_without_properties(_param, [
        "children"
    ]);
    return _jsx(Stack, _object_spread_props(_object_spread({
        spacing: 5
    }, stackProps), {
        children: children
    }));
};
export var FormIntro = function(_param) /*#__PURE__*/ {
    var children = _param.children, textProps = _object_without_properties(_param, [
        "children"
    ]);
    return _jsx(Text, _object_spread_props(_object_spread({
        mb: 5
    }, textProps), {
        children: children
    }));
};
export var CheckboxControlOptions = function(param) {
    var options = param.options, name = param.name;
    return options.map(function(o) {
        return /*#__PURE__*/ _jsx(CheckboxControl, {
            name: name,
            value: o.value,
            children: o.label
        }, o.value);
    });
};
